import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SliderComponent from "containers/homePage/components/slider";
import { useHistory, useParams } from "react-router-dom";
import { get, post } from "@/network/axiosClient";
import { Button, message } from "antd";
import { useLayoutContext } from "@/components/common/menu/Menu";
import {
	hideLoading,
	showLoading,
} from "@/components/common/loading/store/slice";
import styles from "./home.module.scss";
import TopTable from "./components/TopTable";
import FAQ from "./components/FAQ";
import Launchpad from "./components/Launchpad";
import { getAuthorizationHeader } from "@/utils/authentication";
interface UseParams {
	categoryName: string;
	id: string;
}

interface ICategory {
	category: any;
	created_at: string;
	id: string;
	name: string;
	position: string;
	status: string;
}

const HomePage = () => {
	const { categoryName }: UseParams = useParams();

	const dispatch = useDispatch();
	const history = useHistory();

	const { categories: categoriesFilter } = useLayoutContext();
	const [categories, setCategories] = useState<ICategory[]>();

	useEffect(() => {
		async function fetchData() {
			let params = {};
			dispatch(showLoading());
			if (categoryName) {
				params = {
					skip: 0,
					limit: 10,
					sort: { field: "created_at", order: -1 },
					filter: [
						{
							name: "category",
							value:
								categoriesFilter?.find((_c) => _c?.name === categoryName)?.id ??
								"",
							operator: "eq",
						},
					],
				};
			} else {
				params = {
					skip: 0,
					limit: 10,
					sort: {
						field: "created_at",
						order: -1,
					},
					filter: [
						{
							name: "position",
							value: "HOME",
							operator: "eq",
							status: "SHOW",
						},
					],
				};
			}

			try {
				const res: any = await post("/sub-categories/search", params);

				if (res?.data.success === true) {
					setCategories(res?.data?.data?.docs ?? []);
				}
				dispatch(hideLoading());
			} catch (e) {
				message.error(e?.message);
				dispatch(hideLoading());
			}
		}
		fetchData();
	}, [categoryName]);

	useEffect(() => {
		get("/moralis/collection-nfts", {
			headers: getAuthorizationHeader(),
		});
	}, []);

	return (
		<div className={styles.home}>
			<SliderComponent />

			<div className="p-8">
				<div className={styles.home_item}>
					<div className={styles.item_header}>
						<h1>Launchpad</h1>
						<Button
							onClick={() =>
								history.push({
									pathname: "/launchpad",
								})
							}
						>
							View all
						</Button>
					</div>
					<Launchpad />
				</div>

				{/* <div className={styles.home_item}>
          <div className={styles.item_header}>
            <h1>Feature Showcase</h1>
          </div>
          <Showcase />
        </div> */}

				<div className={styles.home_item}>
					<h1>Top Monbase Collections</h1>
					<TopTable />
				</div>

				<div className={styles.home_item}>
					<h1>FAQ</h1>
					<FAQ />
				</div>
			</div>
		</div>
	);
};

export default HomePage;
